module.exports = __webpack_public_path__ + "img/IT0000283631254.d27a16ef.png";